import React, { Component } from 'react';
import Base from '../../rebase';
import { 
  PageHeader
} from 'react-bootstrap';
import PropTypes from 'prop-types';

class Title extends Component {

  render() {
    return (
      <div>
      {
        this.props.items.map((item, index) => (
          <PageHeader>{item.title}</PageHeader>
        ))
      }
      </div>
      )
  }
}

export default Title;

Title.propTypes = {
    items: PropTypes.array.isRequired
}


// WEBPACK FOOTER //
// ./src/reusable_components/page_components/Title.jsx